module.exports = __webpack_public_path__ + "static/changelog-portal-large-f9880dfe9fb1e1b0092c7b1aabb8f38b.png";